export type Plan = {
  id: "solo-monthly" | "solo-yearly" | "team-monthly" | "team-yearly";
  tier: "solo" | "team";
  billing: "monthly" | "yearly";
  name: string;
  tagline: string;
  price: string;
  priceSub: string;
  priceId: string;
  features: string[];
  badge?: string;
  highlighted?: boolean;
};

// Paddle Price IDs
export const PADDLE_PRICE_SOLO_MONTHLY =
  process.env.NEXT_PUBLIC_PADDLE_PRICE_SOLO_MONTHLY || "pri_01km3ddvrwdhtt3zv4rbb3yeb8";
export const PADDLE_PRICE_SOLO_YEARLY =
  process.env.NEXT_PUBLIC_PADDLE_PRICE_SOLO_YEARLY || "pri_01km3ddw42y6h2be8phh9h8r2h";
export const PADDLE_PRICE_TEAM_MONTHLY =
  process.env.NEXT_PUBLIC_PADDLE_PRICE_TEAM_MONTHLY || "pri_01km3ddwcaqaa58d5e8q419a53";
export const PADDLE_PRICE_TEAM_YEARLY =
  process.env.NEXT_PUBLIC_PADDLE_PRICE_TEAM_YEARLY || "pri_01km3ddwmq8shqhvt9bevg1s63";
export const PADDLE_PRICE_CREDIT_TOPUP =
  process.env.NEXT_PUBLIC_PADDLE_PRICE_CREDIT_TOPUP || "pri_01km3ddwwadjstxcsemvk8475a";
export const PADDLE_PRICE_CALL_TOPUP =
  process.env.NEXT_PUBLIC_PADDLE_PRICE_CALL_TOPUP || "pri_01km3ddx4a9gjg32c86z9b37c8";

export const plans: Plan[] = [
  {
    id: "solo-monthly",
    tier: "solo",
    billing: "monthly",
    name: "Solo",
    tagline: "For individual reps",
    price: "€149",
    priceSub: "/ month",
    priceId: PADDLE_PRICE_SOLO_MONTHLY,
    features: [
      "15,000 credits / month",
      "Browser-based VoIP calling",
      "Automatic call recording & transcription",
      "AI-generated call summaries & outcomes",
      "Outcome-based workflow automation",
      "Lead discovery (Google Maps, CSV, web forms)",
      "Smart calling lists & filters",
      "Phone scripts during live calls",
      "Email outreach & templates",
      "Basic analytics",
    ],
  },
  {
    id: "solo-yearly",
    tier: "solo",
    billing: "yearly",
    name: "Solo",
    tagline: "For individual reps",
    price: "€124",
    priceSub: "/ month · billed €1,490/year",
    priceId: PADDLE_PRICE_SOLO_YEARLY,
    badge: "Save 17%",
    features: [
      "15,000 credits / month",
      "Browser-based VoIP calling",
      "Automatic call recording & transcription",
      "AI-generated call summaries & outcomes",
      "Outcome-based workflow automation",
      "Lead discovery (Google Maps, CSV, web forms)",
      "Smart calling lists & filters",
      "Phone scripts during live calls",
      "Email outreach & templates",
      "Basic analytics",
    ],
  },
  {
    id: "team-monthly",
    tier: "team",
    billing: "monthly",
    name: "Team",
    tagline: "For growing sales teams",
    price: "€149",
    priceSub: "/ seat / month",
    priceId: PADDLE_PRICE_TEAM_MONTHLY,
    highlighted: true,
    features: [
      "15,000 credits / seat / month",
      "Everything in Solo",
      "Unlimited seats",
      "Team management & roles",
      "Role-based permissions",
      "Advanced analytics",
      "Agent leaderboards",
      "Priority support",
    ],
  },
  {
    id: "team-yearly",
    tier: "team",
    billing: "yearly",
    name: "Team",
    tagline: "For growing sales teams",
    price: "€124",
    priceSub: "/ seat / month · billed €1,495/seat/year",
    priceId: PADDLE_PRICE_TEAM_YEARLY,
    badge: "Save 17%",
    highlighted: true,
    features: [
      "15,000 credits / seat / month",
      "Everything in Solo",
      "Unlimited seats",
      "Team management & roles",
      "Role-based permissions",
      "Advanced analytics",
      "Agent leaderboards",
      "Priority support",
    ],
  },
];
